import {MigrationApplyFn, ModelMigration} from '@/engine/types/model/migration';
import {Migration, MigrationStep} from '@/model/types';
import {Model} from '../../types/model';
import {createStepPredicate} from './conditions';
import {getOperationFactory} from './operations';

export const getStepApplyFn = (migration: MigrationStep, model: Model): MigrationApplyFn => {
  const predicate = createStepPredicate(migration);
  const operation = getOperationFactory(migration.operation)(model);

  return data => {
    if (!predicate(data)) return data;
    return operation(data);
  };
};

export const createMigrations = (migrations: Migration[], model: Model): ModelMigration[] => {
  return migrations.map(migration => {
    const steps = migration.steps.map(({conditions, ...step}) => ({...step, apply: getStepApplyFn(step, model)}));
    return {...migration, steps};
  });
};
